import { useMobile } from '@sonnen/web-ui';
import { GraphDesktop } from '../../../assets/GraphDesktop';
import { GraphMobile } from '../../../assets/GraphMobile';

export const EnergyDynamicUSP = () => {
  const mobile = useMobile();

  return <div data-testid="energy-dynamic-usp">{mobile ? <GraphMobile /> : <GraphDesktop />}</div>;
};
